import React, { useState, useEffect, useCallback, useRef } from 'react'

const computeSum = (api, dataGetter) => {
    let sum = 0
    api.forEachNodeAfterFilter(node => {
        if (!node.data) return
        const raw = dataGetter(node.data)
        const value = Number(raw)
        if (raw != null && !Number.isNaN(value)) sum += value
    })
    return sum
}

export default function ColumnSumHeader(params) {
    const {
        api, column, displayName, enableSorting, enableMenu,
        showColumnMenu, setSort, t, getFormattedAmount, language, numberOfDecimals, dataGetter
    } = params

    const menuButtonRef = useRef(null)
    const [sortDirection, setSortDirection] = useState(column.getSort())
    const [filterActive, setFilterActive] = useState(column.isFilterActive())
    const [sum, setSum] = useState(() => computeSum(api, dataGetter))

    const refreshSum = useCallback(() => {
        setSum(computeSum(api, dataGetter))
    }, [api, dataGetter])

    useEffect(() => {
        refreshSum()
        api.addEventListener('modelUpdated', refreshSum)
        return () => api.removeEventListener('modelUpdated', refreshSum)
    }, [refreshSum, api])

    useEffect(() => {
        const onSortChanged = () => setSortDirection(column.getSort())
        column.addEventListener('sortChanged', onSortChanged)
        return () => column.removeEventListener('sortChanged', onSortChanged)
    }, [column])

    useEffect(() => {
        const onFilterChanged = () => setFilterActive(column.isFilterActive())
        api.addEventListener('filterChanged', onFilterChanged)
        return () => api.removeEventListener('filterChanged', onFilterChanged)
    }, [api, column])

    const onSortRequested = (event) => {
        if (!enableSorting) return
        const next = sortDirection === 'asc' ? 'desc' : sortDirection === 'desc' ? null : 'asc'
        setSort(next, event.shiftKey)
    }

    return (
        <div
            className="ag-header-cell-label"
            title={`${t('sum', { disableCapitalize: true })} : ${getFormattedAmount(sum, numberOfDecimals, language)}`}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', cursor: enableSorting ? 'pointer' : 'default' }}
            onClick={onSortRequested}
        >
            <span className="ag-header-cell-text">{displayName}</span>
            <span style={{ display: 'flex', alignItems: 'center' }}>
                {filterActive && <span className="ag-icon ag-icon-filter" />}
                {sortDirection === 'asc' && <span className="ag-icon ag-icon-asc" />}
                {sortDirection === 'desc' && <span className="ag-icon ag-icon-desc" />}
                {enableMenu && (
                    <span
                        ref={menuButtonRef}
                        className="ag-icon ag-icon-menu"
                        onClick={(event) => { event.stopPropagation(); showColumnMenu(menuButtonRef.current) }}
                    />
                )}
            </span>
        </div>
    )
}